var _a;
import { __decorate, __extends } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ImageHelper, FormResolution } from "../helper/image-helper";
var mediaQueries = require('../../media-queries.json');
import { default as SliderHelper } from "../../slider-helper";
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
var HotelCardImageWrapper = /** @class */ (function (_super) {
    __extends(HotelCardImageWrapper, _super);
    function HotelCardImageWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ImageHelper = new ImageHelper();
        _this.FormResolution = FormResolution;
        _this.emptyImage = {
            mobile: 'https://gips.ltur.com/gips/scalr/original/images.ltur.com/images/content/placeholder-hotel-card-M.jpg',
            mobile2x: 'https://gips.ltur.com/gips/scalr/original/images.ltur.com/images/content/placeholder-hotel-card-M@2.jpg',
            tablet: 'https://gips.ltur.com/gips/scalr/original/images.ltur.com/images/content/placeholder-hotel-card-T.jpg',
            tablet2x: 'https://gips.ltur.com/gips/scalr/original/images.ltur.com/images/content/placeholder-hotel-card-T@2.jpg',
            desktop: 'https://gips.ltur.com/gips/scalr/original/images.ltur.com/images/content/placeholder-hotel-card-D.jpg'
        };
        _this.glideOptions = {
            type: 'carousel',
            perView: 1,
            gap: 0,
            direction: 'ltr'
        };
        _this.currentSlideIndex = 0;
        _this.nextSlideIndex = null;
        _this.lastSlideIndex = 4;
        //@ts-ignore
        _this.mqData = mediaQueries;
        _this.sliderEnabled = false;
        return _this;
    }
    HotelCardImageWrapper.prototype.beforeMount = function () {
        this.sliderEnabled = SliderHelper.isSliderEnabled();
    };
    HotelCardImageWrapper.prototype.handleInit = function (event) {
        //@ts-ignore
        var slider = this.$refs.glide.$el;
        var firstSlide = slider.querySelector('[data-glide-index="0"]');
        SliderHelper.insertLazyImages(firstSlide);
        var secondSlide = slider.querySelector('[data-glide-index="1"]');
        SliderHelper.insertLazyImages(secondSlide);
        var lastSlide = slider.querySelector('[data-glide-index="' + this.lastSlideIndex + '"]');
        SliderHelper.insertLazyImages(lastSlide);
    };
    HotelCardImageWrapper.prototype.handleBeforeChange = function (data) {
        if (data.direction === '=') {
            this.currentSlideIndex = parseInt(data.steps);
        }
        else {
            if (data.direction === '>') {
                this.currentSlideIndex++;
                this.nextSlideIndex = this.currentSlideIndex + 1;
                if (this.currentSlideIndex > this.lastSlideIndex) {
                    this.currentSlideIndex = 0;
                }
                if (this.nextSlideIndex > this.lastSlideIndex) {
                    this.nextSlideIndex = 0;
                }
            }
            else {
                this.currentSlideIndex--;
                this.nextSlideIndex = this.currentSlideIndex - 1;
                if (this.currentSlideIndex < 0) {
                    this.currentSlideIndex = this.lastSlideIndex;
                }
                if (this.nextSlideIndex < 0) {
                    this.nextSlideIndex = this.lastSlideIndex;
                }
            }
        }
        //@ts-ignore
        var slider = this.$refs.glide.$el;
        slider.querySelectorAll('[data-glide-index="' + this.currentSlideIndex + '"]').forEach(function (item) {
            SliderHelper.insertLazyImages(item);
        });
        slider.querySelectorAll('[data-glide-index="' + this.nextSlideIndex + '"]').forEach(function (item) {
            SliderHelper.insertLazyImages(item);
        });
    };
    HotelCardImageWrapper.prototype.handler = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    HotelCardImageWrapper.prototype.handleBuild = function () {
        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        }, 400);
    };
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "hotelName", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "hotelImages", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "tourOperatorCode", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "isDeal", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "outletImage", void 0);
    __decorate([
        Prop({ default: "https://images.ltur.com/images/headline/Deal-2.svg" })
    ], HotelCardImageWrapper.prototype, "dealImage", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "flexTooltip", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "flylocoTooltip", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "dealTooltip", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "isPlaceholder", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "galleryEnabled", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "dotsEnabled", void 0);
    __decorate([
        Prop()
    ], HotelCardImageWrapper.prototype, "countdown", void 0);
    HotelCardImageWrapper = __decorate([
        Component({
            components: (_a = {},
                _a[Glide.name] = Glide,
                _a[GlideSlide.name] = GlideSlide,
                _a)
        })
    ], HotelCardImageWrapper);
    return HotelCardImageWrapper;
}(Vue));
export default HotelCardImageWrapper;
